<template>
  <div class="comments-box">
    <CommentsList
      :entityId="entityId"
      :entityType="entityType"
      :parentId="null"
      :open="true"
    ></CommentsList>
  </div>
</template>

<script>
import { startsWith } from 'lodash'
import CommentsList from 'CORE/components/comments/list'

export default {
    name: 'Comments',
    components: {
        CommentsList,
    },
    props: {
        entityId: {
            type: String,
            required: true,
        },
        entityType: {
            type: String,
            required: true,
        },
    },
    mounted() {
        window.onhashchange = function(e) {
            if (startsWith(window.location.hash, '#comment-')) {
                const commentElementId = window.location.hash.substr(1, 999)
                const el = document.getElementById(commentElementId)
                // console.info(el)
                el.parentElement.classList.add('highlighted-comment')
                setTimeout(function() {
                    this.parentElement.classList.remove('highlighted-comment')
                }.bind(el), 1100)
            }
        }
    },
}
</script>

<style lang="scss">
    .comments-box {
      margin: 10px;
    }
    .highlighted-comment {
        animation-name: bg-blink;
        animation-duration: 500ms;
        animation-delay: 100ms;
        animation-iteration-count: 2;
    }
    @keyframes bg-blink {
        from {
            background-color: var(--warning);
        }
        to {
            background-color: transparent;
        }
    }
</style>
